module.exports = __webpack_public_path__ + "img/11.76304390.jpg";